import React from 'react';

import { Card, CardContent, CardHeader, CardTitle, StackedBarChart } from '@mesh.ai/rabbit';
import OverviewSection from 'Deer/components/Overview/OverviewSection';
import useLocalStorageCards from 'Deer/hooks/useLocalStorageCards';
import { setIsCardOpen } from 'Deer/slice/DeerCollapsibleCard.slice';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { checkSandboxStaticDataFeaturesEnabled, checkNewStaticDataFeaturesEnabled } from 'utils/helpers/featureFlags';
import { getUniqueCardKey } from 'utils/helpers/getUniqueCardKey';

// using dummy data as per the requirement

export const DirectReportsPerformanceCheckIns = () => {
  const history = useHistory();

  const dispatch = useDispatch();
  const currentURL = history.location.pathname;

  const localStorageKey = getUniqueCardKey({ url: currentURL, cardId: 'myDirectTeamPerformanceCheckInsOverview' });

  const isCardOpen = useLocalStorageCards({
    localStorageKey,
    card: 'performanceCheckInsOverview',
    section: 'myDirectTeam',
  });

  const handleChange = (newVal: boolean) => {
    dispatch(
      setIsCardOpen({
        card: 'performanceCheckInsOverview',
        section: 'myDirectTeam',
        isCardOpen: newVal,
        localStorageKey,
      })
    );
    return newVal;
  };
  return (
    <OverviewSection
      open={isCardOpen}
      onOpenChange={handleChange}
      title="Performance check-ins"
      showCaption={checkSandboxStaticDataFeaturesEnabled() || checkNewStaticDataFeaturesEnabled()}
      subTitleColor="warning"
      subTitle="Your team's check-in frequency has dropped in recent months. In your next 1:1, consider discussing with Ming and George why they may be disengaged and not updating their performance as frequently."
    >
      <Card>
        <CardHeader>
          <CardTitle>Check-in frequency</CardTitle>
        </CardHeader>
        <CardContent>
          <div style={{ height: '230px' }}>
            <StackedBarChart
              ref={{
                current: '[Circular]',
              }}
              mode="full"
              nodes={[
                {
                  id: '121',
                  name: 'Helen Mirren',
                },
                {
                  id: '122',
                  name: 'Ming Ye',
                },
                {
                  id: '123',
                  name: 'George Weber',
                },

                {
                  id: '126',
                  name: 'Jay Chandra',
                },
              ]}
              series={[
                {
                  data: [1, 3, 5, 2, 9, 6],
                  id: '121',
                },
                {
                  data: [5, 2.4, 4, 1, 2, 2],
                  id: '122',
                },
                {
                  data: [7, 8, 6, 3, 1, 2],
                  id: '123',
                },
                {
                  data: [4, 8, 9, 1, 1, 2],
                  id: '124',
                },

                {
                  data: [2, 5, 8, 1, 3, 5],
                  id: '126',
                },
                {
                  data: [7, 9, 8, 1, 3, 5],
                  id: '127',
                },
              ]}
              tooltipTitle="Progress"
              xAxisLabel="Months"
              xAxisValues={['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']}
              yAxisDomain={[0, 30]}
              yAxisLabel="Check-in counts"
              seriesSelectorTitle="Team members"
            />
          </div>
        </CardContent>
      </Card>
    </OverviewSection>
  );
};
